// src/utils/configNotifiche.js
// Chiave pubblica per le notifiche sul dispositivo (Firebase Cloud Messaging, "Web Push").
// Si genera una volta sola: Console Firebase → Impostazioni progetto → Cloud Messaging →
// Certificati push web → «Genera coppia di chiavi», e si incolla qui la chiave PUBBLICA
// (è fatta per stare nel codice dell'app, non è un segreto).
// Finché resta vuota, le notifiche popup semplicemente non si attivano: nient'altro cambia.
export const VAPID_KEY = "BOIc4yG2zyRPx5Kh1gXYf9nMrpASQTl78LEgagw5tODN-OuA2ZI1ku1YKT4QgdmfAgJfk8X3LW2i-Bd_8AbA6MY";
